// @copyright  2006-2022 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: 'entity-feeds/archive',
        component: () =>
            import(/* webpackChunkName: "crm.entity-feeds" */ '@/pages/[organisation]/crm/entity-feeds/archived-entity-feeds.vue'),
        name: 'crm.entity-feeds.archived-entity-feeds',
        meta: {
            loginRequired: true,
            permission: 'access.crm.timeline.update-entity-feed',
        },
    },
    {
        path: 'entity-feeds/archive/:feedId',
        component: () =>
            import(/* webpackChunkName: "crm.entity-feeds" */ '@/pages/[organisation]/crm/entity-feeds/archived-entity-feed/[id].vue'),
        name: 'crm.entity-feeds.view-archived-entity-feed',
        meta: {
            loginRequired: true,
            permission: 'access.crm.timeline.update-entity-feed',
        },
    },
    {
        path: 'entity-feeds',
        component: () =>
            import(/* webpackChunkName: "crm.entity-feeds" */ '@/pages/[organisation]/crm/entity-feeds/entity-feeds.vue'),
        name: 'crm.entity-feeds.search-entity-feeds',
        meta: {
            loginRequired: true,
            permission: 'access.crm.timeline.view-entity-feeds',
        },
    },
    {
        path: 'entity-feeds/new',
        component: () =>
            import(/* webpackChunkName: "crm.entity-feeds" */ '@/pages/[organisation]/crm/entity-feeds/entity-feed/new.vue'),
        name: 'crm.entity-feeds.create-entity-feed',
        meta: {
            loginRequired: true,
            permission: 'access.crm.timeline.create-entity-feed',
        },
    },
    {
        path: 'entity-feeds/:feedId',
        component: () =>
            import(/* webpackChunkName: "crm.entity-feeds" */ '@/pages/[organisation]/crm/entity-feeds/entity-feed/[id].vue'),
        name: 'crm.entity-feeds.view-entity-feed',
        meta: {
            loginRequired: true,
            permission: 'access.crm.timeline.view-entity-feeds',
        },
    },
];
